import Vue from 'vue';
import VueResource from 'vue-resource';
import Router from 'vue-router';

import SignUp from './pages/SignUp';
import LogIn from './pages/LogIn';
import Account from './pages/Account';
import Home from './pages/Home';
import Deployments from './pages/Deployments.vue';
import Deployment from './pages/Deployment.vue';
import Deploy from './pages/Deploy.vue';
import Authorize from './pages/Authorize.vue';
import SetupPayment from './pages/SetupPayment.vue';
import Pricing from './pages/Pricing.vue';

Vue.use(Router);
Vue.use(VueResource);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/login',
      name: 'LogIn',
      component: LogIn
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/account/setup-payment',
      name: 'SetupPayment',
      component: SetupPayment,
      meta: {
        requiresAuth: true,
      },
      props: true
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/deployments',
      name: 'Deployments',
      component: Deployments,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/deployment/:id',
      name: 'Deployment',
      component: Deployment,
      meta: {
        requiresAuth: true,
      },
      props: true
    },
    {
      path: '/deploy',
      name: 'Deploy',
      component: Deploy,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/authorize',
      name: 'Authorize',
      component: Authorize,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/pricing',
      name: 'Pricing',
      component: Pricing,
    },
  ],
});

export default router;